/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Valve_Edit_Calibration_WarningInputs */



/**
* | output |
* | --- |
* | "A high coefficient can generate overconsumption" |
*
* @param {Valve_Edit_Calibration_WarningInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const valve_edit_calibration_warning = /** @type {((inputs?: Valve_Edit_Calibration_WarningInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Valve_Edit_Calibration_WarningInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("A high coefficient can generate overconsumption")
	return /** @type {LocalizedString} */ ("Un coefficient important peut générer une surconsommation")
});